module.exports = __webpack_public_path__ + "img/44400.3097170a.jpg";